import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { IAC_APP_CONFIG } from './app/app.config';

bootstrapApplication(AppComponent, IAC_APP_CONFIG).catch((err) => {
  console.error('Application failed to bootstrap:', err);
  document.body.innerHTML = `
    <div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;text-align:center;padding:2rem;">
      <div>
        <h1 style="font-size:1.5rem;margin-bottom:0.5rem;">Application failed to load</h1>
        <p style="color:#666;">Please reload the page. If the problem persists, contact support.</p>
        <button onclick="location.reload()" style="margin-top:1rem;padding:0.5rem 1.5rem;cursor:pointer;">Reload</button>
      </div>
    </div>`;
});
